import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import MainContentLayout from '../../components/Layout/MainContentLayout';
import AddService from './AddService';

const AddEditService = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'service'
        });
    } , []);
    return (
        
        <>
            <AddService />
        </>
        
    )
}

export default AddEditService;
